import { NavLink, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { usePrefs } from "@/hooks/usePrefs";
import { Star, Clock, Building2, FolderKanban, Boxes, Megaphone, MessageSquare, FileText } from "lucide-react";

const TYPE_ICON = { organization: Building2, project: FolderKanban, item: Boxes, campaign: Megaphone, conversation: MessageSquare };

export function FavoritesList({ compact }) {
  const { favorites } = usePrefs();
  const location = useLocation();
  if (!favorites.length) return null;
  return (
    <div className="px-2 pt-3" data-testid="favorites-list">
      <p className="px-3 pb-1 text-[11px] font-medium text-slate-500 flex items-center gap-1.5"><Star className="w-3 h-3" /> Favorites</p>
      {favorites.map((f) => <NavLink key={f.to} to={f.to} className={cn("nav-item py-[5px]", location.pathname === f.to && "active")} data-testid={`fav-${f.to.replace(/\//g, "-").slice(1)}`}><Star className="w-3.5 h-3.5 opacity-60" style={{ color: "var(--signal)" }} /><span className="truncate">{compact ? f.label.split(" · ").pop() : f.label}</span></NavLink>)}
      <div className="mt-2 border-t border-white/[0.06]" />
    </div>);
}

export function RecentsList() {
  const { recents } = usePrefs();
  if (!recents.length) return null;
  return (
    <div className="px-2 pb-3 pt-2 border-t border-white/[0.06]" data-testid="recents-list">
      <p className="px-3 pb-1 text-[11px] font-medium text-slate-500 flex items-center gap-1.5"><Clock className="w-3 h-3" /> Recent</p>
      {recents.slice(0, 5).map((r) => { const I = TYPE_ICON[r.type] || FileText; return <NavLink key={r.link} to={r.link} className="nav-item py-[5px]" data-testid="recent-item"><I className="w-3.5 h-3.5 opacity-60" /><span className="truncate">{r.label}</span></NavLink>; })}
    </div>);
}
